export enum NlpRequestType {
  LIVE = 'Live',
  HISTORICAL = 'Historic',
  ANALYSIS = 'Analysis',
}
